import React from 'react'
import Header from "./Header"
import Gallery from './Gallery'
import Sbox from './Sbox'
import Contact from './Contact'
import Aboutus from './Aboutus'
import Services from './Services'
import Gallery2 from './Gallery2'



function Home() {
    return (
        <div>

            <Gallery2 />
            <Aboutus />
            <Services />
            <Contact />



        </div>
    )
}

export default Home
